import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-banner-section',
  templateUrl: './banner-section.component.html',
  styleUrls: ['./banner-section.component.scss']
})
export class BannerSectionComponent implements OnInit {
  @Input() content: any;
  constructor() { }

  ngOnInit(): void {
  }

}
